import React from "react";
import { useNavigate } from "react-router-dom";
import StarRating from "./StarRating";
import { Skull } from "lucide-react";

export function BandRow({ band }) {
  const navigate = useNavigate();
  return (
    <button
      data-testid="band-row"
      onClick={() => navigate(`/bands/${band.id}`)}
      className="group w-full text-left flex items-center gap-4 bg-zinc-900 border border-zinc-800 rounded-sm px-4 py-3 hover:border-zinc-600 transition-colors"
    >
      <div className="w-12 h-12 shrink-0 rounded-sm overflow-hidden bg-zinc-950 flex items-center justify-center">
        {band.logo_url ? (
          <img src={band.logo_url} alt={band.name} className="w-full h-full object-cover" />
        ) : (
          <Skull size={20} className="text-zinc-700" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          {band.flag && <span className="text-base leading-none">{band.flag}</span>}
          <h3 className="heading text-base font-semibold text-white truncate">{band.name}</h3>
        </div>
        <p className="text-sm text-zinc-400 truncate">
          {band.genre}{band.subgenre ? ` · ${band.subgenre}` : ""}
        </p>
      </div>
      <span className="hidden sm:inline-block label-caps text-xs px-2 py-1 bg-zinc-800 text-primary rounded-sm shrink-0">
        {band.category}
      </span>
      <div className="shrink-0">
        <StarRating value={band.rating || 0} size={16} testid={`row-rating-${band.id}`} />
      </div>
    </button>
  );
}

export default function BandCard({ band }) {
  const navigate = useNavigate();
  return (
    <button
      data-testid="band-card"
      onClick={() => navigate(`/bands/${band.id}`)}
      className="group text-left bg-zinc-900 border border-zinc-800 rounded-sm overflow-hidden hover:border-zinc-600 hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative h-44 bg-zinc-950 overflow-hidden">
        {band.logo_url ? (
          <img
            src={band.logo_url}
            alt={band.name}
            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-700">
            <Skull size={48} />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/20 to-transparent" />
        <span className="absolute top-2 right-2 text-xs label-caps px-2 py-1 bg-black/70 border border-white/10 text-primary rounded-sm">
          {band.category}
        </span>
      </div>
      <div className="p-4 space-y-2">
        <div className="flex items-center gap-2">
          {band.flag && <span className="text-lg leading-none">{band.flag}</span>}
          <h3 className="heading text-lg font-semibold text-white truncate">{band.name}</h3>
        </div>
        <p className="text-sm text-zinc-400 truncate">
          {band.genre}{band.subgenre ? ` · ${band.subgenre}` : ""}
        </p>
        <StarRating value={band.rating || 0} testid={`card-rating-${band.id}`} size={16} />
      </div>
    </button>
  );
}
